export default "__VITE_ASSET__Cdy_AyWU__"